import { env } from '@/shared/lib/env';
import {
  getGraphqlEndpoint,
  isGraphqlEndpointUrl,
  setGraphqlEndpoint,
} from '@/shared/lib/graphql-endpoint';

const DISCO_URL = env.VITE_DISCO_URL ?? 'https://disco.elscms.com';

export const discoverBackendForEmail = async (email: string): Promise<boolean> => {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const res = await fetch(`${DISCO_URL}/v1/lookup`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ email }),
    });
    if (!res.ok) {
      return false;
    }

    const body = (await res.json()) as { backend_url?: unknown };
    if (typeof body.backend_url !== 'string' || !isGraphqlEndpointUrl(body.backend_url)) {
      return false;
    }

    if (body.backend_url === getGraphqlEndpoint()) {
      return false;
    }

    setGraphqlEndpoint(body.backend_url);
    return true;
  } catch {
    return false;
  }
};
